import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { initKvIntro } from '../animation/kv-intro';

gsap.registerPlugin(ScrollTrigger, SplitText);

initKvIntro({
  titleSelector: '.js-members-title',
  subtitleSelector: '.js-members-subtitle',
  leadSelector: '.js-members-lead',
});

window.addEventListener('load', () => {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        gsap.utils.toArray('.p-aboutus-groups__section').forEach(el => {
          gsap.set(el, { opacity: 0 });
          gsap.to(el, {
            opacity: 1,
            ease: 'power3.out',
            duration: 0.8,
            scrollTrigger: {
              trigger: el,
              start: 'top 80%',
              once: true,
            },
          });
        });

        ScrollTrigger.refresh();
      });
    });
  } else {
    ScrollTrigger.refresh();
  }
});
